/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Header from "../../../components/Header";
import DataGridButton from "../../../components/DataGridButton";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Typography,
  useTheme,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { tabbedDataGridPage } from "../../../styles/commonPageStyles";
import DbSoftware from "./DbSoftware";
import { useListAllEngines } from "../../../api/softwareImages";
import { useNavigate } from "react-router-dom";
import { useGetReleases } from "../../../api/releases";
import { APPS } from "../../../utils/constants";
import { useNotification } from "../../../components/Notification";
import { MAIN_BRANCH } from "../../../utils/constants";
import { dataGridButtonTypography } from "../../../styles/DataGridStyles";
import { dataGridButtonStyles } from "../../../styles/buttonStyles";
import styles from "../styles";
import { tokens } from "../../../theme";
import { toKebabCase } from "../../../utils/helperFunctions";
import Os from "./Os";

const queryParamsForGetReleases = "?loadRepos=false&loadCommits=false";

const SoftwareImagesView = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedTab, setSelectedTab] = useState("db-software");
  const [releases, setReleases] = useState([]);
  const { notificationComponent, displayNotification } = useNotification();

  const [releaseBranch, setReleaseBranch] = useState(MAIN_BRANCH);

  const [engine, setEngine] = useState("mysql");
  const navigate = useNavigate();

  const { postData: listAllEngines, response: listAllEnginesResp } =
    useListAllEngines();

  const [reloadToggle, setReloadToggle] = useState(false);
  const { postData: getReleases, response: getReleasesResp } = useGetReleases(
    APPS.TESSELL
  );

  useEffect(() => {
    getReleases(queryParamsForGetReleases);
    listAllEngines();
  }, []);

  useEffect(() => {
    navigate(`/apps/tessell/software-images/${selectedTab}`);
  }, [selectedTab]);

  useEffect(() => {
    if (getReleasesResp?.response?.length) {
      setReleases(
        getReleasesResp.response?.map(
          (releaseJson) => releaseJson?.release_label
        )
      );
    }
  }, [getReleasesResp]);

  const SOFTWARE_IMAGE_TYPES = ["DB Software", "OS"];

  return (
    <Box sx={tabbedDataGridPage.mainBox}>
      <Box sx={tabbedDataGridPage.tabContainer}>
        <TabContext value={selectedTab}>
          <Box sx={tabbedDataGridPage.tabListBox}>
            <TabList
              onChange={(e, newValue) => setSelectedTab(newValue)}
              textColor="secondary"
              indicatorColor="secondary"
              sx={tabbedDataGridPage.tabList}
            >
              {SOFTWARE_IMAGE_TYPES?.map((swiType, i) => (
                <Tab
                  key={i}
                  label={swiType}
                  value={toKebabCase(swiType?.toLowerCase())}
                  icon={<></>}
                  iconPosition="end"
                />
              ))}
            </TabList>
          </Box>
          {SOFTWARE_IMAGE_TYPES?.map((swiType, i) => (
            <TabPanel key={i} value={toKebabCase(swiType?.toLowerCase())}>
              <Box sx={tabbedDataGridPage.tabContentMainBox}>
                {notificationComponent}
                <Grid
                  sx={tabbedDataGridPage.gridContainer}
                  container
                  columns={2}
                >
                  <Grid xs={1}>
                    <Header
                      title={swiType}
                      subtitle={`View all ${swiType?.toLowerCase()} of ${engine}`}
                    />
                  </Grid>
                  <Grid xs={1}>
                    <Box sx={tabbedDataGridPage.topButtonStack}>
                      <DataGridButton
                        sx={dataGridButtonStyles.pageTopButtons}
                        onClick={() => setReloadToggle((prev) => !prev)}
                      >
                        <Typography sx={dataGridButtonTypography(colors, 500)}>
                          RELOAD
                        </Typography>
                      </DataGridButton>
                      <FormControl sx={styles.viewSelectForm}>
                        <InputLabel id="elect-release-branch">
                          Release
                        </InputLabel>
                        <Select
                          labelId="select-release-branch"
                          id="elect-release-branch"
                          value={releaseBranch}
                          sx={styles.viewSelectSelect}
                          label="Release Branch"
                          onChange={(e) => setReleaseBranch(e.target.value)}
                        >
                          {[MAIN_BRANCH, ...(releases || [])].map(
                            (release, i) => (
                              <MenuItem value={release} key={i}>
                                {release}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                      <FormControl sx={styles.viewSelectForm}>
                        <InputLabel id="elect-engine">Engine</InputLabel>
                        <Select
                          labelId="select-engine"
                          id="elect-engine"
                          value={engine}
                          sx={styles.viewSelectSelect}
                          label="Engine"
                          onChange={(e) => setEngine(e.target.value)}
                        >
                          {listAllEnginesResp?.dbEngines?.map((engine, i) => (
                            <MenuItem value={engine} key={i}>
                              {engine}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                </Grid>
                {swiType === "DB Software" ? (
                  <DbSoftware
                    engine={engine}
                    releaseBranch={releaseBranch}
                    displayNotification={displayNotification}
                    reloadToggle={reloadToggle}
                  />
                ) : (
                  <Os
                    engine={engine}
                    releaseBranch={releaseBranch}
                    displayNotification={displayNotification}
                    reloadToggle={reloadToggle}
                  />
                )}
              </Box>
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </Box>
  );
};

export default SoftwareImagesView;
